(function () {
  'use strict';
  var CFG = window.MR_CFG || {};
  var modal = document.getElementById('mrModal');
  if (!modal) return;
  if (modal.parentNode !== document.body) document.body.appendChild(modal);
  modal.hidden = false;
  modal.style.display = 'none';

  var form = document.getElementById('mrForm');
  var steps = [].slice.call(form.querySelectorAll('.stepv'));
  var total = steps.length;
  var i = 0;
  var data = {};
  var discountCode = '';

  var bar = document.getElementById('mrBar');
  var label = document.getElementById('mrLabel');
  var back = document.getElementById('mrBack');
  var next = document.getElementById('mrNext');
  var funbar = document.getElementById('mrFunbar');
  var whoOther = document.getElementById('mrWhoOther');
  var occOther = document.getElementById('mrOccOther');

  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function lei(n) { n = Number(n) || 0; return n.toLocaleString('ro-RO', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' lei'; }
  function chips(hostId, arr, name) {
    var host = document.getElementById(hostId);
    if (!host) return;
    host.innerHTML = (arr || []).map(function (v) {
      v = String(v).trim();
      if (!v) return '';
      return '<label class="chip"><input type="radio" name="' + name + '" value="' + esc(v) + '"><span>' + esc(v) + '</span></label>';
    }).join('');
  }

  chips('mrWhoChips', CFG.rel, 'who');
  chips('mrOccChips', CFG.occ, 'occasion');
  chips('mrStyleChips', CFG.style, 'style');
  chips('mrEmoChips', CFG.emo, 'emotion');
  chips('mrVoiceChips', CFG.voice, 'voice');

  var SPEED = [
    { v: 'standard', t: CFG.speedStd || 'Livrare standard', s: CFG.speedStdSub || 'în 2–4 zile lucrătoare', tag: 'Gratuit' },
    { v: 'priority', t: CFG.speedPrio || 'Livrare prioritară – sub 24h', s: CFG.speedPrioSub || 'o primești în maximum 24 de ore', tag: '+' + lei(CFG.priorityPrice) }
  ];
  document.getElementById('mrSpeedOpts').innerHTML = SPEED.map(function (o, n) {
    return '<label class="opt' + (n === 0 ? ' sel' : '') + '"><input type="radio" name="speed" value="' + o.v + '"' + (n === 0 ? ' checked' : '') + '>' +
      '<span><b>' + esc(o.t) + '</b><small>' + esc(o.s) + '</small></span><span class="tag">' + esc(o.tag) + '</span></label>';
  }).join('');

  function open() {
    modal.style.display = 'flex';
    modal.classList.add('open');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    render();
  }
  function close() {
    modal.style.display = 'none';
    modal.classList.remove('open');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }
  [].forEach.call(document.querySelectorAll('[data-mr-open]'), function (b) { b.addEventListener('click', open); });
  document.getElementById('mrClose').addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('open')) close(); });

  function val(name) {
    var el = form.elements[name];
    if (!el) return '';
    if (el.length && el[0] && el[0].type === 'radio') {
      var c = [].filter.call(el, function (r) { return r.checked; })[0];
      return c ? c.value : '';
    }
    return (el.value || '').trim();
  }
  function syncCond() {
    whoOther.hidden = val('who') !== (CFG.otherWho || 'Altcineva');
    occOther.hidden = val('occasion') !== (CFG.otherOcc || 'Altă ocazie');
  }
  form.addEventListener('change', function (e) {
    if (e.target.name === 'who' || e.target.name === 'occasion') syncCond();
  });

  function collect() {
    ['who', 'who_other', 'name', 'occasion', 'occasion_other', 'story', 'special', 'style', 'emotion', 'voice', 'phone', 'speed'].forEach(function (k) { data[k] = val(k); });
  }
  function whoLabel() { return data.who === (CFG.otherWho || 'Altcineva') ? (data.who_other || data.who) : data.who; }
  function occLabel() { return data.occasion === (CFG.otherOcc || 'Altă ocazie') ? (data.occasion_other || data.occasion) : data.occasion; }
  function phoneOk(v) { return v.replace(/\D/g, '').length >= 9; }

  function validate() {
    var ok = true;
    steps[i].querySelectorAll('.fld[data-req]').forEach(function (f) {
      if (f.hidden) { f.classList.remove('bad'); return; }
      var k = f.getAttribute('data-req');
      var v = val(k);
      var bad = k === 'phone' ? !phoneOk(v) : !v;
      if (bad) { f.classList.add('bad'); ok = false; } else f.classList.remove('bad');
    });
    return ok;
  }

  function render() {
    steps.forEach(function (s, n) { s.classList.toggle('on', n === i); });
    syncCond();
    var last = i === total - 1;
    var p = Math.round((i + 1) / total * 100);
    bar.style.width = p + '%';
    label.textContent = 'Pasul ' + (i + 1) + ' din ' + total;
    back.style.visibility = i === 0 ? 'hidden' : 'visible';
    next.style.display = last ? 'none' : '';
    next.textContent = 'Continuă →';
    funbar.hidden = !last;
    if (last) {
      collect();
      document.getElementById('mrName').textContent = data.name || whoLabel() || 'persoana ta dragă';
      var wasEl = document.getElementById('mrWas');
      document.getElementById('mrSong').textContent = lei(CFG.songPrice);
      document.getElementById('mrPrioPrice').textContent = lei(CFG.priorityPrice);
      if (CFG.songCompare && CFG.songCompare > CFG.songPrice) wasEl.textContent = lei(CFG.songCompare);
      updTotal();
    }
    modal.scrollTo(0, 0);
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    collect();
    if (!validate()) return;
    if (i < total - 1) { i++; render(); } else finalize();
  });
  back.addEventListener('click', function () { if (i > 0) { i--; render(); } });
  form.addEventListener('input', function (e) {
    var f = e.target.closest('.fld');
    if (f) f.classList.remove('bad');
  });
  document.getElementById('mrSpeedOpts').addEventListener('change', function () {
    [].forEach.call(this.querySelectorAll('.opt'), function (o) { o.classList.toggle('sel', o.querySelector('input').checked); });
    updTotal();
  });

  document.getElementById('mrCodeToggle').addEventListener('click', function () {
    var w = document.getElementById('mrCodeWrap');
    w.hidden = !w.hidden;
    if (!w.hidden) document.getElementById('mrCode').focus();
  });

  function updTotal() {
    var withPrio = val('speed') === 'priority';
    document.getElementById('mrPrioLine').hidden = !withPrio;
    var t = Number(CFG.songPrice) + (withPrio ? Number(CFG.priorityPrice) : 0);
    document.getElementById('mrTotal').textContent = lei(t);
    document.getElementById('mrBarTotal').textContent = lei(t);
  }

  document.getElementById('mrApply').addEventListener('click', function () {
    var code = (document.getElementById('mrCode').value || '').trim();
    var msg = document.getElementById('mrCodeMsg');
    if (!code) { msg.className = 'disc__msg no'; msg.textContent = 'Introdu un cod.'; return; }
    discountCode = code;
    msg.className = 'disc__msg ok';
    msg.textContent = 'Codul „' + code + '” va fi aplicat la finalizare.';
  });

  document.getElementById('mrGo').addEventListener('click', finalize);

  function finalize() {
    collect();
    if (!validate()) return;
    var usePriority = data.speed === 'priority';
    var props = {
      'Pentru cine': whoLabel(),
      'Numele destinatarului': data.name,
      'Ocazia': occLabel(),
      'Povestea': data.story,
      'Vers/mesaj special': data.special || '—',
      'Stil muzical': data.style,
      'Emoție': data.emotion,
      'Voce': data.voice,
      'Telefon WhatsApp': data.phone,
      'Viteza livrării': usePriority ? 'Prioritară – sub 24h' : 'Standard 2-4 zile'
    };
    var items = [{ id: Number(CFG.songVariantId), quantity: 1, properties: props }];
    if (usePriority && CFG.priorityVariantId) items.push({ id: Number(CFG.priorityVariantId), quantity: 1 });

    var go = document.getElementById('mrGo');
    go.disabled = true;
    go.textContent = 'Se procesează…';

    var base = CFG.checkoutBase || '/';
    var dest = discountCode
      ? base + 'discount/' + encodeURIComponent(discountCode) + '?redirect=' + encodeURIComponent('/checkout')
      : base + 'checkout';

    fetch(base + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(function () {
        return fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.j && res.j.description) || 'Nu am putut adăuga în coș.');
        window.location.href = dest;
      })
      .catch(function (err) {
        go.disabled = false;
        go.textContent = CFG.submitLabel || 'Finalizează comanda →';
        var msg = document.getElementById('mrCodeMsg');
        msg.className = 'disc__msg no';
        msg.textContent = err.message;
      });
  }
})();
